export default function(data) {
var __t, __p = '';
__p += '// Injects auth tokens into the page and listens for their change\n// See apps/backoffice/src/composables/use-auth.ts\n\nwindow.tokensToSet = [' +
((__t = ( data.accessTokenStr )) == null ? '' : __t) +
', ' +
((__t = ( data.refreshTokenStr )) == null ? '' : __t) +
'];\n\nwindow.onTokensChanged = (accessToken, refreshToken) => {\n    const message = JSON.stringify({ accessToken, refreshToken });\n\n    webkit.messageHandlers.cordova_iab.postMessage(message);\n};\n';
return __p
}